export function ReportTemplate({
                                   headerLeft,
                                   headerRight,
                                   bodyLeft,
                                   bodyRight,
                                   typeAnswerTable = false,
                                   bodyTotal
                               }: {
    headerLeft?: React.ReactNode;
    headerRight?: React.ReactNode;
    bodyLeft?: React.ReactNode;
    bodyRight?: React.ReactNode;
    typeAnswerTable?: boolean;
    bodyTotal?: React.ReactNode
}) {
    return (
        <div className="result">
            {/* 25.06.10 리포트 화면 고도화 */}
            <div className="report_study">
                {bodyTotal ?
                    <div className='table-con'>
                        {/* 25.06.10 리포트 화면 고도화 - ai 총평 */}
                        {bodyTotal}
                    </div>
                    :
                    <div className="table-con">
                        {/*{bodyLeft}*/}
                        {/*25.06.10 리포트 화면 고도화 - 콘텐츠 상시 테이블 / 학생 선택 시 테이블,채점 결과, 교사피드백*/}
                        {bodyRight}
                    </div>
                }
            </div>
            {/* //25.06.10 리포트 화면 고도화 */}
        </div>

        /*<div className="report-content">
            <div className="result">
                <div className="contents">
                    <div className="body">
                        <div
                            className={`table-scroll${typeAnswerTable === true ? '' : ' no-scroll'}`}
                        >
                            <div className="table-div">
                                <div className="table-box">
                                    {headerLeft}
                                    {headerRight}
                                </div>
                                {bodyTotal ?
                                    <div className='table-con'>
                                        {bodyTotal}
                                    </div>
                                    :
                                    <div className="table-con">
                                        {bodyLeft}
                                        {bodyRight}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>*/
    );
}
